module.exports = __webpack_public_path__ + "static/img/jieshu2.7477060.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/jieshu2.png
// module id = DtXJ
// module chunks = 24